import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FilterTagType } from './filter-tag.types';

@Component({
  selector: 'wfm-filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrls: ['./filter-tag.component.scss']
})
export class FilterTagComponent {
  @Input() type: FilterTagType = FilterTagType.default;

  @Input() fillColor = false;

  @Input() hideCloseButton = false;

  @Output() close = new EventEmitter();

  get classes(): string[] {
    return [
      (this.fillColor && 'filter-tag--fill') || 'filter-tag--outline',
      (this.fillColor && this.type !== FilterTagType.default && `filter-tag--${this.type}`) || ''
    ];
  }
}
